import { useTranslation } from 'react-i18next';
import { MedicalReadMore } from 'autogen/translation-keys/trans-website-shared-buttons';
import { Button, ButtonWithIcon } from 'components/Button';
import Icon from 'components/Icon';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import eventCategoryToContext from 'modules/tracking/GA4/helpers/eventCategoryToContext';
import type { TrackingCategory } from 'modules/tracking/UAEventTracking';
import type { ProductActionProps } from '../../shared/types';

function track(eventCategory: TrackingCategory) {
    const context = eventCategoryToContext(eventCategory);

    if (context) {
        GA4Tracking({
            eventName: 'read_more',
            context,
            category: 'ecommerce',
            eventParams: [{ param_name: 'read_more_type', param_value: 'medical_description' }]
        });
    }
}

export function MedicalReadMoreButton({
    params,
    trackingInfo,
    children,
    ...restProps
}: ProductActionProps['MedicalReadMore']) {
    const { t } = useTranslation();
    const { eventCategory } = trackingInfo;

    return (
        <Button as="a" href={params.productNavigationLink.url} onClick={() => track(eventCategory)} {...restProps}>
            {children || t(MedicalReadMore)}
        </Button>
    );
}

export function MedicalReadMoreButtonCompact({
    params,
    trackingInfo,
    ...restProps
}: ProductActionProps['MedicalReadMore']) {
    const { eventCategory } = trackingInfo;
    const { t } = useTranslation();

    return (
        <ButtonWithIcon
            as="a"
            href={params.productNavigationLink.url}
            icon={<Icon type="ChevronRight" size={16} fill="white" />}
            aria-label={t(MedicalReadMore)}
            onClick={() => track(eventCategory)}
            {...restProps}
        />
    );
}

export default Object.assign(MedicalReadMoreButton, {
    Compact: MedicalReadMoreButtonCompact
});
